"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WELCOME_EMAIL_ENABLED = exports.ENABLED = exports.DOI_SETTINGS = void 0;
var DOI_SETTINGS = 'DoiSettings';
exports.DOI_SETTINGS = DOI_SETTINGS;
var ENABLED = 'enabled';
exports.ENABLED = ENABLED;
var WELCOME_EMAIL_ENABLED = 'welcomeEmailEnabled';
exports.WELCOME_EMAIL_ENABLED = WELCOME_EMAIL_ENABLED;